export const DASHBOARD_VIEW_NAME = "Product Dashboard View";
export const URL_PATTERN = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*(\?[^\s]*)?$/;
 export const ANALYTICAL_PRODUCT = "analyticalProduct";

export const REPORT_MAP = {
  "data-quality": 1,
  "code-quality": 2,
  "sfu-usage": 3,
  "cost-monitoring": 4,
  "platform-kpi": 5,
  "product-usage": 6,
  "product-view": 7,
};
export const BUSINESS_FUNCTION_OPTIONS = [
  { value: "mw", label: "MW" },
  { value: "health", label: "Health and Wellness" },
  { value: "immersive", label: "Immersive Experience" },
];
